// Where the Location switcher sends the user (Phase 2 / P2.8 §17).
//
// Small and deterministic: if the current URL is a Location route whose tail is
// a SECTION that exists for every Location (no resource-specific child id —
// overview, a layer landing, the Google Profile tabs, the inbox …), the same
// section is opened under the target Location. Anything else — a page editor,
// a survey, a Business-level screen, an unknown tail — goes to the target
// Location's own overview, the one destination every Location has. Never a
// naive id substitution inside an arbitrary URL.
import { locationRoutes } from './route-map';

/** Section tails that exist for every Location and carry no resource id. */
export const SWITCH_SAFE_TAILS: ReadonlySet<string> = new Set([
  'overview',
  'setup',
  'foundation',
  'foundation/business-info',
  'foundation/website',
  'foundation/website/domain',
  'foundation/mailboxes',
  'foundation/get-found-ready',
  'visibility',
  'visibility/google-profile',
  'visibility/google-profile/content',
  'visibility/google-profile/map',
  'visibility/ai',
  'visibility/aeo',
  'visibility/search',
  'reputation',
  'reputation/reviews',
  'reputation/settings',
  'pulse',
  'pulse/inbox',
  'pulse/leads',
  'pulse/analytics',
  'reports',
]);

const LOCATION_PATH = /^\/app\/b\/([^/]+)\/l\/([^/]+)(?:\/(.*))?$/;

export function switchTarget(currentPathname: string, targetBusinessId: string, targetLocationId: string): string {
  const m = LOCATION_PATH.exec(currentPathname);
  const tail = m?.[3]?.replace(/\/+$/, '') ?? '';
  if (m && tail && SWITCH_SAFE_TAILS.has(tail)) return `/app/b/${targetBusinessId}/l/${targetLocationId}/${tail}`;
  return locationRoutes.overview(targetBusinessId, targetLocationId);
}
